import { useTranslation } from "next-i18next";
import { cn } from "../../../../../lib/utils";

const ASSETS_PATH = "/landings/assets/images/products/hub-talentos";

const DESAFIO_KEYS = ["item01", "item02", "item03", "item04"];
const RESULTADO_KEYS = ["item01", "item02", "item03", "item04", "item05"];

export default function DesafiosResultadosSection() {
	const { t } = useTranslation();

	return (
		<section className="bg-neutral-08">
			<div
				className={cn(
					"container-blog",
					"flex flex-col gap-6",
					"tablet:gap-8",
					"tabletL:flex-row tabletL:items-stretch tabletL:gap-10",
					"laptop:gap-8",
					"laptopM:gap-16"
				)}
			>
				{/* Desafios Card */}
				<div className="flex-1 w-full bg-background-02 border border-ds-system-error-400 rounded-2xl p-5 tablet:p-6 tablet:max-w-[608px] tablet:mx-auto">
					<h3
						className={cn(
							"text-white uppercase tracking-[1.2px] m-0",
							"text-base",
							"tablet:text-xl",
							"laptop:text-2xl"
						)}
					>
						<span className="font-medium !text-white">
							{t("products.hub-talentos.desafiosResultados.desafios.title")}
						</span>
						<br className="tablet:hidden" />
						<span className="font-bold !text-ds-system-error-400">
							{" "}
							{t("products.hub-talentos.desafiosResultados.desafios.titleHighlight")}
						</span>
					</h3>

					<ul className="list-none p-0 mt-4 tablet:mt-6 flex flex-col gap-3 tablet:gap-4">
						{DESAFIO_KEYS.map((key) => (
							<li key={key} className="flex items-center gap-3 tablet:gap-2 laptop:gap-3">
								<img
									src={`${ASSETS_PATH}/icon-x.svg`}
									alt=""
									className="w-5 h-5 tablet:w-4 tablet:h-4 laptop:w-6 laptop:h-6 shrink-0"
								/>
								<span
									className={cn(
										"!text-white font-medium",
										"text-sm leading-6",
										"tablet:text-sm tablet:leading-[22px]",
										"laptop:text-lg laptop:leading-7"
									)}
								>
									{t(`products.hub-talentos.desafiosResultados.desafios.items.${key}`)}
								</span>
							</li>
						))}
					</ul>
				</div>

				{/* Resultados Card */}
				<div className="flex-1 w-full bg-background-02 border border-ds-brand-green-300 rounded-2xl p-5 tablet:p-6 tablet:max-w-[608px] tablet:mx-auto">
					<h3
						className={cn(
							"text-white uppercase tracking-[1.2px] m-0",
							"text-base",
							"tablet:text-xl",
							"laptop:text-2xl"
						)}
					>
						<span className="font-medium !text-white">
							{t("products.hub-talentos.desafiosResultados.resultados.title")}
						</span>
						<br className="tablet:hidden" />
						<span className="font-bold !text-ds-brand-green-300">
							{" "}
							{t("products.hub-talentos.desafiosResultados.resultados.titleHighlight")}
						</span>
					</h3>

					<ul className="list-none p-0 mt-4 tablet:mt-6 flex flex-col gap-3 tablet:gap-4">
						{RESULTADO_KEYS.map((key) => (
							<li key={key} className="flex items-center gap-3 tablet:gap-2 laptop:gap-3">
								<img
									src={`${ASSETS_PATH}/icon-check.svg`}
									alt=""
									className="w-5 h-5 tablet:w-4 tablet:h-4 laptop:w-6 laptop:h-6 shrink-0"
								/>
								<span
									className={cn(
										"!text-white font-medium",
										"text-sm leading-6",
										"tablet:text-sm tablet:leading-[22px]",
										"laptop:text-lg laptop:leading-7"
									)}
								>
									{t(`products.hub-talentos.desafiosResultados.resultados.items.${key}`)}
								</span>
							</li>
						))}
					</ul>
				</div>
			</div>
		</section>
	);
}
